import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["data-selected"]
const _hoisted_3 = ["value", "checked", "onChange"]
const _hoisted_4 = { "data-option-title": "" }

import { useId } from 'vue'


export default {
  __name: 'PillRadioGroup',
  props: {
  modelValue: { type: [String, Number, Boolean], default: null },
  options: { type: Array, required: true },
  label: { type: String, required: true }
},
  emits: ['update:modelValue'],
  setup(__props) {




const groupName = `pills-${useId()}`

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "radiogroup",
    "aria-label": __props.label,
    class: "flex flex-wrap gap-2"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("label", {
        key: String(option.value),
        "data-option": "",
        "data-selected": String(option.value === __props.modelValue),
        class: _normalizeClass(["cursor-pointer rounded-full border px-4 py-[9px] text-sm transition has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-gray-900", 
        option.value === __props.modelValue
          ? 'border-gray-900 bg-gray-900 font-semibold text-white'
          : 'border-gray-300 bg-white text-gray-900 hover:border-gray-400'
      ])
      }, [
        _createElementVNode("input", {
          type: "radio",
          class: "sr-only",
          name: groupName,
          value: String(option.value),
          checked: option.value === __props.modelValue,
          onChange: $event => (_ctx.$emit('update:modelValue', option.value))
        }, null, 40, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(option.name), 1)
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

}